<template>
    <b-card>
        <b-card-title>
            <strong>Campos de peligros asociados</strong>
        </b-card-title>

        <div v-if="section">
            <b-alert show variant="primary" v-if="section.prod_dangers.length === 0">La sección <strong>{{ section.name
                    }}</strong> no tiene
                Peligros
                CAS asociados</b-alert>
            <b-list-group v-else>
                <b-list-group-item v-for="danger in section.prod_dangers" :key="danger.id" class="p-0 shadow-sm content-fields mb-1 rounded-md">
                    <div v-b-toggle="`collapse-${danger.id}`"
                        class="d-flex align-items-center justify-content-between items-danger p-2">
                        <div>
                            <strong>{{ danger.list.lista }}</strong>
                            <div class="d-flex align-items-center gap-2">
                                <p class="text-muted m-0 text-capitalize">Campos disponibles <b-badge variant="light"
                                        pill>{{ danger.danger_fields.length }}</b-badge></p>
                                <span class="mx-3">|</span>
                                <p class="text-muted m-0 text-capitalize">Seleccionados <b-badge variant="primary"
                                        pill>{{ dangerFieldsSelectedBySection(danger.id) }}</b-badge></p>
                            </div>
                        </div>
                    </div>

                    <b-collapse :id="`collapse-${danger.id}`" class="content-fields px-3">
                        <b-card no-body border-variant="0">
                            <p class="card-text"></p>
                            <div class="list-group-item-field" v-for="field in danger.danger_fields" :key="field.id"
                                @click="() => selectField(field)" :class="{ 'fiel-selected': checkSelected(field) }">
                                <span>{{ field.label }}</span>
                                <i :class="checkSelected(field) ? 'fa fa-check-circle text-primary ml-2' : ''"></i>
                            </div>
                        </b-card>
                    </b-collapse>

                </b-list-group-item>
            </b-list-group>

            <b-alert show variant="light" class="mt-3 shadow" v-if="section && column.danger_fields_id && column.danger_fields_id.length > 0">
                <strong><b-badge variant="primary" pill>{{ column.danger_fields_id.length }}</b-badge> Campos serán asociados a la columna: {{ column.name }}</strong>

                <b-form-group label="Separador" class="mt-3">
                    <b-form-select class="form-control w-25" v-model="column.separator_to_grouped_fields" :options="optionsSeparator" size="sm">
                        <b-form-select-option value="" disabled>
                            
                        </b-form-select-option>
                    </b-form-select>
                </b-form-group>

                <p>Vista previa: {{ column.danger_fields_id.map(x => x.label).join(` ${getSeparator} `) }}</p>
            </b-alert>

        </div>

        <b-alert v-else show variant="danger">No se ha seleccionado una sección</b-alert>

    </b-card>
</template>

<script>

// Generales
import { mapState, mapMutations } from "vuex";

export default {
    name: "ConfigFieldDangers",

    computed: {

        ...mapState("colums", ["column", "dataSections", "optionsSeparator"]),

        section() {
            return this.dataSections.find(x => x.id === this.column.slq_inventory_section_id);
        },

        getSeparator() {
            const separator = this.optionsSeparator.find(x => x.value === this.column.separator_to_grouped_fields);
            return separator ? (separator.value === 'blank-space' ? '' : separator.value) : '';
        }

    },

    methods: {

        ...mapMutations("colums", ["setColumn"]),

        selectField(field) {
            let currentDangerFieldsId = [...this.column.danger_fields_id];
            if (this.checkSelected(field)) {
                currentDangerFieldsId = this.column.danger_fields_id.filter(x => x.id !== field.id)
            }
            else currentDangerFieldsId.push(field)

            this.setColumn({ 
                ...this.column,
                danger_fields_id: currentDangerFieldsId
            })
        },

        dangerFieldsSelectedBySection(dangerId) {
            return this.column.danger_fields_id.filter(x => x.prod_danger_id === dangerId).length;
        },

        checkSelected(field) {
            return this.column.danger_fields_id.find(x => x.id === field.id);
        }
    }

}

</script>

<style scoped>

.items-danger {
    cursor: pointer;
}

.items-danger:hover {
    background-color: #f5f5f5;
    opacity: 0.5;
}

.content-fields {
    border: 0px;
}

.list-group-item-field {
    cursor: pointer;
    padding: 0.5rem 1rem;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border-left: 3px solid #f8f8f8;
}

.list-group-item-field:hover {
    background-color: #eeeeee;
    opacity: 0.5;
}

.fiel-selected {
    background-color: #f8f9fa;
    border-left: 3px solid #007bff;
}
</style>